import styled, { createGlobalStyle } from 'styled-components'

export const SortPositionModalGlobalStyle = createGlobalStyle`
  .sort-position-modal {
    .ant-modal-content {
      border-radius: 12px !important;
      overflow: hidden;
      box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
    }

    .ant-modal-header {
      padding: 18px 24px !important;
      border-bottom: 1px solid #f1f5f9 !important;
      background: #ffffff !important;
    }

    .ant-modal-title {
      font-family: "Inter", Noto Sans Display, sans-serif !important;
      font-size: 18px !important;
      font-weight: 600 !important;
      color: #0f172a !important;
    }

    .ant-modal-close {
      top: 18px !important;
      right: 20px !important;
      color: #64748b !important;

      &:hover {
        color: #0f172a !important;
      }
    }

    .ant-modal-body {
      padding: 24px !important;
    }
  }
`

export const SortModalWrapper = styled.div`
  font-family: "Inter", Noto Sans Display, sans-serif !important;
`

export const InstructionNote = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #475569;
  font-family: "Inter", Noto Sans Display, sans-serif !important;
  margin-bottom: 16px;
  padding: 10px 14px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px dashed #cbd5e1;

  .anticon {
    color: #1d68a5;
    font-size: 15px;
  }
`

export const ListWrapper = styled.ul`
  padding-left: 0;
  margin: 0;
  max-height: 420px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-right: 4px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #e2e8f0;
    border-radius: 9999px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #cbd5e1;
  }
`

export const SortItem = styled.li`
  display: flex;
  align-items: center;
  padding: 10px 14px;
  list-style: none;
  font-size: 14px;
  font-family: "Inter", Noto Sans Display, sans-serif !important;
  color: #1e293b;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  user-select: none;
  z-index: 99999;

  &:hover {
    border-color: #9cd4fc;
    background: #f8fafc;
    box-shadow: 0 2px 8px rgba(112, 174, 251, 0.14);
  }
`

export const DragHandleWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  color: #94a3b8;
  cursor: grab;
  font-size: 16px;
  transition: color 0.2s ease;

  &:hover {
    color: #1d68a5;
  }

  &:active {
    cursor: grabbing;
  }
`

export const SortModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #f1f5f9;

  .btn-cancel {
    height: 38px !important;
    padding: 0 18px !important;
    border-radius: 8px !important;
    border: 1px solid #e2e8f0 !important;
    color: #475569 !important;
    font-family: "Inter", Noto Sans Display, sans-serif !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    background: #ffffff !important;
    transition: all 0.2s ease !important;

    &:hover {
      border-color: #cbd5e1 !important;
      color: #1e293b !important;
      background: #f8fafc !important;
    }
  }

  .btn-submit {
    height: 38px !important;
    padding: 0 22px !important;
    border-radius: 8px !important;
    font-family: "Inter", Noto Sans Display, sans-serif !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    background: #1d68a5 !important;
    border-color: #1d68a5 !important;
    color: #ffffff !important;
    box-shadow: 0 2px 6px rgba(29, 104, 165, 0.2) !important;
    transition: all 0.2s ease !important;

    &:hover {
      background: #155589 !important;
      border-color: #155589 !important;
      box-shadow: 0 4px 12px rgba(29, 104, 165, 0.3) !important;
    }
  }
`
